import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Pages where scroll position should survive navigating away and back
// (e.g. list -> customer view -> back to list)
const SCROLL_RESTORE_PATHS = ["/customers", "/prospect-suspect"];

const savedPositions = new Map<string, number>();

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Only scroll to top for full page navigation, not modal routes
    const isModalRoute = pathname.includes('/activity/') || pathname.includes('/customer/create-suspect');

    if (isModalRoute) {
      return;
    }

    if (SCROLL_RESTORE_PATHS.includes(pathname)) {
      // Restore over a few frames since the list may not have reached its
      // full height on the first paint
      const target = savedPositions.get(pathname) ?? 0;
      let attempts = 0;
      let cancelled = false;
      const tryRestore = () => {
        if (cancelled) return;
        window.scrollTo(0, target);
        if (window.scrollY < target && attempts++ < 20) {
          requestAnimationFrame(tryRestore);
        }
      };
      requestAnimationFrame(tryRestore);

      const onScroll = () => savedPositions.set(pathname, window.scrollY);
      window.addEventListener("scroll", onScroll, { passive: true });
      return () => {
        cancelled = true;
        window.removeEventListener("scroll", onScroll);
      };
    }

    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
